import { z } from 'zod';

export const teamMemberSchema = z.object({
  team_member: z.object({
    name: z.string({ message: 'Email is required' }),
    email: z.string({ message: 'Email is required' }).email({ message: 'Please enter a valid email address' }),
    phone_number: z
      .union([z.string().nonempty({ message: 'Phone number is required' }), z.number()])
      .optional()
      .nullable(),
    role: z.string({ message: 'Role is required' })
  })
});

export const agencyTeamMemberSchema = z.object({
  team_member: z.object({
    name: z.string({ message: 'Email is required' }),
    email: z.string({ message: 'Email is required' }).email({ message: 'Please enter a valid email address' }),
    phone_number: z
      .union([z.string().nonempty({ message: 'Phone number is required' }), z.number()])
      .optional()
      .nullable(),
    agency_role: z.string({ message: 'Role is required' })
  })
});
